export const environment = {
  newBavelCollect: true,
  form01Enabled: true,
  production: true,
  traceRoutes: false,
  isDefaulterEnabled: true,
  auth0: {
    domain: 'idppay.voxelgroup.net',
    clientId: 'NMZauEOYLtU8sYIQoowycTsSqGqJYeIN',
    audience: 'PaymentManagerApi',
    logoutUri: 'https://www.bavelpay.com',
    redirectUri: 'https://www.bavelpay.com/account/oauth-callback',
    scope: 'openid profile offline_access',
    cacheLocation: 'memory' as const
  },
  userSession:
  {
    inactivityLogout: 60 * 15,
    inactivityWarning: 60 * 14,
  },
  urls: {
    api: 'https://prm.voxelgroup.net/api',
    activation: 'https://bavelactivation.voxelgroup.net/activation',
    extranetJS: 'https://prm.voxelgroup.net',
    falcon: 'https://bavel.voxelgroup.net',
    partnerPortal: 'https://partnerportal.voxelgroup.net',
    apiPayments: 'https://api.bavelpay.com'
  },
  languageService:
  {
    LanguageCookieName: 'UserCulture',
    LanguageCookieDomain: 'voxelgroup.net',
  }
};
